import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import uniqueId from "lodash/uniqueId";
import { Type } from "discover.medical.react-component-library";
import { ALL_FILTER, PPC_FILTER, updateTypes } from "./constants";
import { Alert, Filters } from "./_.styled";
import { SubscribeCard } from "./SubscribeCard";

const AlertItems = ({ alerts, renderSubscribeCard, showFilters = true }) => {
  const [activeFilter, setActiveFilter] = useState(ALL_FILTER);
  const [filteredAlerts, setFilteredAlerts] = useState([]);

  useEffect(() => {
    const updateType =
      activeFilter === PPC_FILTER ? updateTypes.PPC : updateTypes.UNFILTERED;
    alerts && setFilteredAlerts(alerts[updateType]);
  }, [activeFilter, alerts]);

  const renderPPCText =
    activeFilter === PPC_FILTER && alerts.practice?.length === 0;

  return (
    <>
      {showFilters && (
        <Filters
          setActiveFilter={setActiveFilter}
          activeFilter={activeFilter}
        />
      )}
      {filteredAlerts?.length > 0 ? (
        filteredAlerts.map((alert, idx) => {
          if (idx === 1 && renderSubscribeCard) {
            return (
              <Fragment key={uniqueId()}>
                <Alert alert={alert} />
                <SubscribeCard />
              </Fragment>
            );
          }
          return <Alert key={uniqueId()} alert={alert} />;
        })
      ) : (
        <>
          {renderSubscribeCard && <SubscribeCard />}
          {renderPPCText && (
            <Type element="p" marginBottom="md">
              There are no recent potentially practice-changing alerts.
            </Type>
          )}
        </>
      )}
    </>
  );
};

AlertItems.propTypes = {
  alerts: PropTypes.object,
  renderUpdateBanner: PropTypes.bool,
};

export default AlertItems;
